import type { ReactNode } from 'react';
import Dismiss from '../../../../../ui/Dismiss/Dismiss';
import styles from '../Disco.module.css';

interface CoverModalProps {
  children: ReactNode;
  onClose: () => void;
  onBackdropClick: () => void;
  noPadding?: boolean;
}

export function CoverModal({
  children,
  onClose,
  onBackdropClick,
  noPadding,
}: CoverModalProps) {
  const modalClassName = noPadding
    ? `${styles.coverModal} ${styles.coverModalNoPadding}`
    : styles.coverModal;

  return (
    <div
      className={styles.coverOverlay}
      onClick={onBackdropClick}
      role="presentation"
    >
      <div
        className={modalClassName}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
      >
        <div className={styles.coverCloseBtn}>
          <Dismiss onClick={onClose} />
        </div>
        {children}
      </div>
    </div>
  );
}
